"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVehicles = fetchVehicles;
exports.vehicleLabel = vehicleLabel;
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
async function fetchVehicles() {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}mileage/vehicles`, {
        credentials: "include",
    });
    if (!response.ok)
        throw new Error("Nie udało się pobrać listy pojazdów.");
    const vehicles = await response.json();
    // Baza oddaje identyfikator jako liczbę, a lista wyboru i adres trasy operują napisem.
    // Wyrównujemy go tutaj, żeby porównania w formularzach nie milkły po cichu.
    return vehicles.map((vehicle) => ({ ...vehicle, id: String(vehicle.id) }));
}
/** Auto w jednym napisie: "Ford Focus OP 8105L". */
function vehicleLabel(vehicle) {
    return [vehicle.brand, vehicle.model, vehicle.plate].filter(Boolean).join(" ");
}
